import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonSize", "defaultValue", "devices", "dropdownStyles", "extraDevices", "onChange", "iconButtonStyles"];
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EPDeviceSelectDropdown from './EPDeviceSelectDropdown';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { MOBILE, DESKTOP, TABLET, DEFAULT } from './internal/constants';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { DesktopIcon, MobileIcon, TabletIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BUILTIN_DEVICE_TYPES = [MOBILE, DESKTOP, TABLET, DEFAULT];
const DeviceSelectIcon = ({
  iconName
}) => {
  switch (iconName) {
    case MOBILE:
      return /*#__PURE__*/_jsx(MobileIcon, {});
    case DESKTOP:
      return /*#__PURE__*/_jsx(DesktopIcon, {});
    case TABLET:
      return /*#__PURE__*/_jsx(TabletIcon, {});
    case DEFAULT:
      return /*#__PURE__*/_jsx(DesktopIcon, {});
    default:
      return null;
  }
};
const EPDeviceSelectButton = _ref => {
  let {
      buttonSize = 'small',
      defaultValue = MOBILE,
      devices = [{
        name: MOBILE
      }, {
        name: DESKTOP
      }, {
        name: TABLET
      }, {
        name: DEFAULT
      }],
      dropdownStyles = {},
      extraDevices = [],
      onChange,
      iconButtonStyles = {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [activeButton, setActiveButton] = useState(defaultValue);
  const onClickHandler = e => {
    onChange(e);
    setActiveButton(e.target.value);
  };
  const children = devices.reduce((acc, device) => {
    let deviceName;
    let Icon;
    let tooltip;
    if (typeof device === 'object') {
      deviceName = device.name;
      Icon = device.icon;
      tooltip = device.tooltip;
    } else {
      deviceName = device;
    }
    if (BUILTIN_DEVICE_TYPES.includes(deviceName) || tooltip && Icon) {
      const comp = /*#__PURE__*/_jsx(IconButton, Object.assign({
        active: activeButton === deviceName,
        "data-test-id": `toggle-${deviceName}-button`,
        size: buttonSize,
        use: "tertiary-light",
        value: deviceName,
        tooltip: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
          message: `epDeviceSelectButton.${deviceName}`
        }),
        onClick: e => onClickHandler(SyntheticEvent(deviceName, e))
      }, iconButtonStyles, {
        children: Icon ? /*#__PURE__*/_jsx(Icon, {}) : /*#__PURE__*/_jsx(DeviceSelectIcon, {
          iconName: deviceName
        })
      }), deviceName);
      acc.push(comp);
    }
    return acc;
  }, []);
  const {
    tokenProps
  } = filterTokenProps(rest);
  return /*#__PURE__*/_jsx(ButtonGroup, Object.assign({}, tokenProps, {
    children: /*#__PURE__*/_jsxs(Flex, {
      children: [children, /*#__PURE__*/_jsx(EPDeviceSelectDropdown, {
        buttonSize: buttonSize,
        devices: extraDevices,
        dropdownStyles: dropdownStyles,
        onChange: onClickHandler,
        selectedDevice: activeButton
      })]
    })
  }));
};
export const TrellisEpDeviceSelectButton = EPDeviceSelectButton;
export default EPDeviceSelectButton;